import React, { useContext, useEffect, useState } from 'react'
import Navigator from 'app/Components/Navigator'
// import Header from 'app/Components/Header'
import { Box, Stack } from '@mui/material'
import { useSelector } from 'react-redux'
import TopBar from 'app/Components/Topbar'
// import { toggleDrawer } from 'app/Redux/slices/user/Drawer'
import { SnackbarContext } from 'app/Components/SnackbarProvider'
import {
  onMessageListener,
  requestPushNotifications,
} from '../../firebase-config'
import { baseUrl } from 'app/Utils/Config'
import api from 'app/AxiosInstance'

const Layout = ({ children }) => {
  const loggedInUserId = localStorage.getItem(`loggedInUserId`)
  const pushNotificationToken = localStorage.getItem(`pushNotificationToken`)

  const openSnackbar = useContext(SnackbarContext)
  // const dispatch = useDispatch()
  const drawerState = useSelector((state) => state.drawer)

  // const smallAndMediumScreen = useMediaQuery(`(max-width:900px)`)

  // const closeSideBar = (event) => {
  //   event.stopPropagation()
  //   if (drawerState.openDrawer && smallAndMediumScreen) {
  //     dispatch(toggleDrawer({ openDrawer: !drawerState.openDrawer }))
  //   }
  // }

  const [notification, setNotification] = useState(null)

  useEffect(() => {
    // Request Push Notifications and Store Token
    requestPushNotifications().then((token) => {
      if (token) {
        const storedToken = localStorage.getItem('pushNotificationToken')

        if (!storedToken) {
          api.post(`${baseUrl}/push-notifications/device-token`, {
            deviceToken: token,
            userId: loggedInUserId,
            platform: 'web',
          })
          localStorage.setItem('pushNotificationToken', token)
        }
      }
    })

    // Listen for Incoming Messages
    onMessageListener((payload) => {
      setNotification(payload.notification)
      openSnackbar(payload?.notification?.title, 'info', {
        vertical: 'top',
        horizontal: 'right',
      })

      if (
        document.visibilityState === 'visible' &&
        Notification.permission === 'granted'
      ) {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: '../Assets/account_ic.svg',
        })
      }
    })

    //?  Check permission status and remove token if denied/reset
    const checkPermission = async () => {
      if (
        Notification.permission === 'default' ||
        Notification.permission === 'denied'
      ) {
        try {
          // Make sure the token exists before trying to delete it
          const token = localStorage.getItem('pushNotificationToken')

          if (!token) return // Prevent unnecessary API call

          await api.delete(
            `${baseUrl}/push-notifications/device-token/${token}`,
          )

          // Only remove the token from localStorage after a successful API call
          localStorage.removeItem('pushNotificationToken')
        } catch (error) {
          console.error('Error removing push notification token:', error)
        }
      }
    }

    // Run check on mount
    checkPermission()

    // Run check whenever the tab becomes active
    window.addEventListener('focus', checkPermission)

    return () => {
      window.removeEventListener('focus', checkPermission)
    }
  }, [])

  return (
    <Stack direction={`row`}>
      <Box
        sx={{
          flexGrow: 4,
          width: {
            xs: `0px`,

            md: drawerState.openDrawer ? `249px` : `0px`,
          },
        }}
      >
        <Navigator />
      </Box>

      <Box
        sx={{
          flexGrow: 8,
          width: {
            xs: `calc(100% - ${drawerState.openDrawer ? `249px` : `0px`})`,
          },
        }}
        // onClick={(event) => closeSideBar(event)}
      >
        <Box
          sx={{
            flexGrow: 1,
            overflowY: `auto`,
            overflowX: `hidden`,
            width: `100%`,
            maxHeight: `100vh`,
            position: `relative`,
            backgroundColor: `rgba(40, 32, 61, 0.07)`,
          }}
        >
          <TopBar />
          {children}
        </Box>
      </Box>
    </Stack>
  )
}

export default Layout
